import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _createMachine(options={}) {
	return _apiRequestWrap(ModulesMap.MACHINES, ModulesConfigMap[ModulesMap.MACHINES].CREATE_MACHINE, options)
}

function _getAvailableMachines(options={}) {
	return _apiRequestWrap(ModulesMap.MACHINES, ModulesConfigMap[ModulesMap.MACHINES].GET_AVAIABLE_MACHINES, options)
}

function _getPreviewMachine(options={}) {
	return _apiRequestWrap(ModulesMap.MACHINES, ModulesConfigMap[ModulesMap.MACHINES].GET_PREVIEW_MACHINE, options)
}

function _getMachinePopup(options = {}) {
	return _apiRequestWrap(
		ModulesMap.MACHINES,
		ModulesConfigMap[ModulesMap.MACHINES].GET_POPUP_MACHINE,
		options
	)
}

function _deleteMachine(options={}) {
	return _apiRequestWrap(ModulesMap.MACHINES, ModulesConfigMap[ModulesMap.MACHINES].DELETE_MACHINE, options)
}

function _getMachine(options={}) {
	return _apiRequestWrap(ModulesMap.MACHINES, ModulesConfigMap[ModulesMap.MACHINES].GET_MACHINE, options)
}

function _editMachine(options={}) {
	return _apiRequestWrap(ModulesMap.MACHINES, ModulesConfigMap[ModulesMap.MACHINES].EDIT_MACHINE, options)
}

function _getSensorsValues(options={}) {
	return _apiRequestWrap(ModulesMap.MACHINES, ModulesConfigMap[ModulesMap.MACHINES].GET_SENSORS_VALUES, options)
}

function _getRawGPSParams(options={}) {
	return _apiRequestWrap(ModulesMap.MACHINES, ModulesConfigMap[ModulesMap.MACHINES].GET_RAW_GPS_PARAMS, options)
}

function _putMachine(options = {}) {
	return _apiRequestWrap(
		ModulesMap.MACHINES,
		ModulesConfigMap[ModulesMap.MACHINES].PUT_MACHINE,
		options
	)
}

//FUELS

function _getFuelTank(options={}) {
	return _apiRequestWrap(ModulesMap.MACHINES, ModulesConfigMap[ModulesMap.MACHINES].GET_FUEL_TANK, options)
}

function _createFuelTank(options={}) {
	return _apiRequestWrap(ModulesMap.MACHINES, ModulesConfigMap[ModulesMap.MACHINES].CREATE_FUEL_TANK, options)
}

function _editFuelTank(options={}) {
	return _apiRequestWrap(ModulesMap.MACHINES, ModulesConfigMap[ModulesMap.MACHINES].EDIT_FUEL_TANK, options)
}

function _deleteFuelTank(options={}) {
	return _apiRequestWrap(ModulesMap.MACHINES, ModulesConfigMap[ModulesMap.MACHINES].DELETE_FUEL_TANK, options)
}


export default {
	[ModulesConfigMap[ModulesMap.MACHINES].GET_AVAIABLE_MACHINES]: _getAvailableMachines,
	[ModulesConfigMap[ModulesMap.MACHINES].GET_PREVIEW_MACHINE]: _getPreviewMachine,
	[ModulesConfigMap[ModulesMap.MACHINES].GET_POPUP_MACHINE]: _getMachinePopup,

	[ModulesConfigMap[ModulesMap.MACHINES].CREATE_MACHINE]: _createMachine,
	[ModulesConfigMap[ModulesMap.MACHINES].DELETE_MACHINE]: _deleteMachine,
	[ModulesConfigMap[ModulesMap.MACHINES].GET_MACHINE]: _getMachine,
	[ModulesConfigMap[ModulesMap.MACHINES].EDIT_MACHINE]: _editMachine,
	[ModulesConfigMap[ModulesMap.MACHINES].PUT_MACHINE]: _putMachine,

	[ModulesConfigMap[ModulesMap.MACHINES].GET_SENSORS_VALUES]: _getSensorsValues,
	[ModulesConfigMap[ModulesMap.MACHINES].GET_RAW_GPS_PARAMS]: _getRawGPSParams,

	// Fuel tanks
	getFuelTank: _getFuelTank,
	createFuelTank: _createFuelTank,
	editFuelTank: _editFuelTank,
	deleteFuelTank: _deleteFuelTank,
}
